export default __webpack_public_path__ + "static/media/ags-medico-large.b0741d74.png";